<template>
    <div class="">
        <div class="container-fluid bg-white">
            <p class="text-bat fs-6 py-3 mb-0 text-center">
                Contenido interno y exclusivo para los pertenecientes al programa Conectados, con fines
                educativos. Prohibido compartir o distribuir el material fuera de la plataforma Conectados de
                BAT.
            </p>
        </div>

        <footer class="container-fluid py-5 bg-blueIndigoDark">
            <div class="container text-white text-bat">

                <div class="row mb-5 text-center footer-desk">
                    <div class="col-12 px-4">
                        <p class="fs-6 mb-0">
                            <!-- {{
                                client_segment !== 0
                                    ? (shopkeeper_staff.includes(client_segment)
                                        ? 'Material dirigido al canal de comercialización. Prohibida su reproducción total o parcial.'
                                        : 'Conecta2 contigo es una herramienta de trabajo. Material de comunicación de uso interno y dirigido a la fuerza de ventas de BAT.')
                                    : 'Material dirigido al canal de comercialización. Prohibida su reproducción total o parcial. Su acceso a esta página se da en virtud de su relación comercial con Distribuciones La Nieve SAS. Para más información, revise los Términos y condiciones de uso.'
                            }} -->
                            Material dirigido al canal de comercialización de Mega. Prohibida su reproducción total o parcial. Su acceso a esta página se da en virtud de su relación comercial con Distribuciones Mega. Para más información, revise los <a class="footer-link-elegant" target="_blank" :href="tyc">Términos y condiciones de uso</a>.
                        </p>
                    </div>
                </div>

                <div class="row footer-desk">
                    <div class="col-12 col-md-6 pe-md-5 d-flex flex-column align-items-center divider-red">
                        <div class="d-flex align-items-center justify-content-center" style="gap: 50px;">
                            <img :src="logo" alt="logo_conecta2" width="95px" height="45px" />
                            <a href="https://sedeelectronica.sic.gov.co/" target="_blank" rel="noopener">
                                <img src="/img/brand/logo_superintendencia_ic.svg" alt="logo_superintendencia" height="45px" />
                            </a>
                        </div>
                        <!-- <p class="fs-6">Para consultas de Conecta2.</p> -->
                        <!-- <p>Para consultas de Conecta2.</p> -->
                    </div>

                    <div class="col-12 col-md-6 ps-md-5 d-flex flex-column">
                        <div class="d-flex flex-column align-items-center justify-content-center gap-4">
                            <img :src="logo_lanieve" alt="logo_lanieve" width="95px" height="45px" />
                            <!-- <p class="fs-6">Para consultas dirigidas a la relación comercial con Distribuciones La Nieve SAS.</p> -->
                            <!-- <p>Para consultas dirigidas a la relación comercial con Distribuciones La Nieve SAS.</p> -->
                        </div>
                    </div>
                </div>

                <div class="row footer-desk">
                    <div class="col-12 col-md-4 d-flex flex-column">
                        <div class="mt-4">
                            <div class="mb-3">
                                <a class="footer-link-elegant" target="_blank" href="https://sedeelectronica.sic.gov.co/">Superintendencia de Industria y Comercio</a>
                            </div>
                            <div class="mb-3">
                                <a class="footer-link-elegant" target="_blank" href="https://www.batcolombia.com/meta/footer/aviso-de-privacidad">Aviso de privacidad</a>
                            </div>
                            <div class="mb-3">
                                <a class="footer-link-elegant" target="_blank" href="https://www.batcolombia.com/meta/footer/politica-de-privacidad">Política de privacidad</a>
                            </div>

                            <div class="mb-3">
                                <a class="footer-link-elegant" target="_blank" :href="tyc">Términos y condiciones de uso</a>
                            </div>
                            <div class="mb-3" v-if="client_segment !== 0">
                                <a class="footer-link-elegant" href="/preguntas-frecuentes">FAQ</a>
                            </div>
                            <div class="mb-3" v-if="segments_delete_account && segments_delete_account.includes(client_segment)">
                                <a class="footer-link-elegant" href="/account/delete">Cancelar suscripción</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-4 d-flex flex-column divider-red">
                        <div class="mt-4">
                            <div class="d-flex flex-column">
                                <p class="fs-6 mb-0">NIT: <strong>900462511</strong></p>
                                <p class="fs-6 mb-0">Razón social:</p>
                                <p class="fs-6 mb-3"><strong>British American Tobacco Colombia SAS</strong></p>

                                <p class="fs-6 mb-0">Dirección para notificaciones judiciales:</p>
                                <p class="fs-6 mb-3"><strong>Av. carrera 72 #80-94, piso 9</strong></p>

                                <p class="fs-6 mb-0">Correo electrónico para notificaciones judiciales:</p>
                                <a class="text-white text-decoration-none mb-3" href="mailto:alexandra_bernal@bat.com"><strong>alexandra_bernal@bat.com</strong></a>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-4 d-flex flex-column">
                        <div class="mt-4">
                            <div class="d-flex flex-column">
                                <p style="margin: 0;">Para consultas dirigidas a la relación comercial con</p>
                                <p>Distribuciones Mega.</p>

                                <p class="fs-6 mb-0">Líneas de atención <strong>GRATUITA</strong></p>
                                <p class="fs-6 mb-3">Desde cualquier celular <strong>3203414212</strong></p>

                                <p class="fs-6 mb-0">Para consultas sobre protección de datos personales:</p>
                                <a class="text-white text-decoration-none mb-3" href="mailto:datospersonales_colombia@bat.com"><strong>datospersonales_colombia@bat.com</strong></a>

                                <p class="fs-6 mb-0">Canal de atención directa PQRS:</p>
                                <a class="text-white text-decoration-none mb-3" href="mailto:servicioalcliente@bat.com"><strong>servicioalcliente@bat.com</strong></a>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <p class="fs-6 mb-0 text-center mt-4">Si necesitas soporte o asistencia relacionada con Conecta2, deberás gestionarla a través de Victoria.</p>
                    </div>

                    <div class="col-12">
                        <p class="fs-6 mb-0 text-center mt-4">{{ year }} © BAT Colombia. Todos los derechos reservados.</p>
                    </div>
                </div>

                <div class="row">
                    <div class="footer-mobile">
                        <div class="out-accordion">
                            <div class="col-12 col-md-12 mb-4" >
                                <div class="">
                                    <p class="fs-6">
                                        Material dirigido al canal de comercialización de Mega. Prohibida su reproducción total o parcial.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-column align-items-center justify-content-center mb-4">
                                <div class="col-12 d-flex align-items-center justify-content-center mb-4" style="gap: 25px;">
                                    <img :src="logo" alt="logo_conecta2" height="45px" />
                                    <a href="https://sedeelectronica.sic.gov.co/" target="_blank" rel="noopener">
                                        <img src="/img/brand/logo_superintendencia_ic.svg" alt="logo_superintendencia" height="45px" />
                                    </a>
                                </div>
                                <p>Para consultas de Conecta2.</p>
                            </div>

                            <div class="col-12 col-md-12 mb-4">
                                <div class="">
                                    <p class="fs-6 mb-0">
                                        NIT: <strong>900462511</strong>
                                    </p>
                                </div>
                                <div class="">
                                    <p class="fs-6 mb-0">
                                        Razón social:<strong> British American Tobacco Colombia SAS</strong>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="accordion accordion-flush mb-4" id="accordionFooter">
                            <div class="accordion-item" style="border-bottom: 1px solid white">
                                <h2 class="accordion-header" id="heading-court-notifications">
                                    <button class="accordion-button collapsed footer-button-accordion" type="button" data-bs-toggle="collapse" data-bs-target="#court-notifications" aria-expanded="false" aria-controls="court-notifications">
                                        Notificaciones Judiciales
                                    </button>
                                </h2>
                                <div id="court-notifications" class="accordion-collapse collapse" aria-labelledby="heading-court-notifications" data-bs-parent="#accordionFooter">
                                    <div class="accordion-body">
                                        <div class="col-12 col-md-12" >
                                            <div class="text-white mb-3">
                                                <p class="style-text-accordion-body mb-0">Dirección:</p>
                                                <p><strong>Av. carrera 72 #80-94, piso 9</strong></p>
                                            </div>

                                            <div class="text-white mb-3">
                                                <p class="style-text-accordion-body mb-0">Correo electrónico:</p>
                                                <a class="text-white text-decoration-none" href="mailto:alexandra_bernal@bat.com"><strong>alexandra_bernal@bat.com</strong></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="out-accordion mb-4">
                            <div class="col-12 d-flex flex-column align-items-center justify-content-center mb-4">
                                <div class="col-12 d-flex align-items-center justify-content-center mb-4">
                                    <img :src="logo_lanieve" alt="logo_lanieve" height="45px" />
                                </div>
                                <p class="text-center">Para consultas dirigidas a la relación comercial con Distribuciones Mega.</p>
                            </div>
                        </div>

                        <div class="accordion accordion-flush mb-4" id="accordionFooter">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="heading-customer-service">
                                    <button class="accordion-button collapsed footer-button-accordion" type="button" data-bs-toggle="collapse" data-bs-target="#customer-service" aria-expanded="false" aria-controls="customer-service">
                                        Atención al Cliente
                                    </button>
                                </h2>
                                <div id="customer-service" class="accordion-collapse collapse" aria-labelledby="heading-customer-service" data-bs-parent="#accordionFooter">
                                    <div class="accordion-body">
                                        <div class="col-12 col-md-12">
                                            <div class="d-flex flex-column">
                                                <p class="mb-0">Líneas de atención <strong>GRATUITA</strong>:</p>
                                                <p class="mb-3">Desde cualquier celular <strong>3203414212</strong></p>

                                                <p class="mb-0">Protección de datos personales:</p>
                                                <a class="text-white text-decoration-none mb-3" href="mailto:datospersonales_colombia@bat.com"><strong>datospersonales_colombia@bat.com</strong></a>

                                                <p class="mb-0">Atención directa PQRS:</p>
                                                <a class="text-white text-decoration-none mb-3" href="mailto:servicioalcliente@bat.com"><strong>servicioalcliente@bat.com</strong></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item" style="border-bottom: 1px solid white">
                                <h2 class="accordion-header" id="heading-legal-information">
                                    <button class="accordion-button collapsed footer-button-accordion" type="button" data-bs-toggle="collapse" data-bs-target="#legal-information" aria-expanded="false" aria-controls="legal-information">
                                        Información Legal
                                    </button>
                                </h2>
                                <div id="legal-information" class="accordion-collapse collapse" aria-labelledby="heading-legal-information" data-bs-parent="#accordionFooter">
                                    <div class="accordion-body">
                                        <div class="col-12 col-md-12">
                                            <div class="d-flex flex-column">
                                                <a class="text-white text-decoration-none mb-3" href="https://sedeelectronica.sic.gov.co/"><strong>Superintendencia de Industria y Comercio</strong></a>
                                                <a class="text-white text-decoration-none mb-3" href="https://www.batcolombia.com/meta/footer/aviso-de-privacidad"><strong>Aviso de privacidad</strong></a>
                                                <a class="text-white text-decoration-none mb-3" href="https://www.batcolombia.com/meta/footer/politica-de-privacidad"><strong>Política de privacidad</strong></a>
                                                <a class="text-white text-decoration-none mb-3" :href="tyc"><strong>Términos y condiciones de uso</strong></a>
                                                <a v-if="client_segment !== 0" class="text-white text-decoration-none mb-3" href="/preguntas-frecuentes">
                                                    <strong>FAQ</strong>
                                                </a>
                                                <a v-if="segments_delete_account && segments_delete_account.includes(client_segment)" class="text-white text-decoration-none mb-3" href="/account/delete">
                                                    <strong>Cancelar suscripción</strong>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="out-accordion">
                            <div class="col-12 col-md-12 " >
                                <div class="">
                                    <p class="fs-6 mb-2">
                                        Si necesitas soporte o asistencia relacionada con Conecta2, deberás gestionarla a través de Victoria.
                                    </p>
                                </div>

                                <div class="">
                                    <p class="fs-6 mb-2">
                                        {{ year }} © BAT Colombia. Todos los derechos reservados.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
            <br>
        </footer>
    </div>
</template>

<script>
    export default {
        props:{
            client_segment: {
                type: Number,
                default: null,
            },
            segments_delete_account:{
                default: [],
            },
            tyc_sellers:{
                default: [],
            },
            shopkeeper:{
                default: [],
            },
            staff: {
                default: [],
            },
        },
        data(){
            return{
                year: new Date().getFullYear()
            }
        },
        computed: {
            logo() {
                if (this.client_segment === 0 || this.shopkeeper.includes(this.client_segment)|| this.staff.includes(this.client_segment)) {
                    return '/img/brand/logo_header_newlook_footer.svg';
                }
                return '/img/brand/logo_newlook_contigo_footer.svg';
            },
            logo_lanieve() {
                if (this.client_segment === 0 || this.shopkeeper.includes(this.client_segment)|| this.staff.includes(this.client_segment)) {
                    return '/img-version2/brand/mega/logo_footer_legales_300x127.svg';
                }
                return '/img-version2/brand/mega/logo_footer_contigo300x127.svg';
            },
            tyc(){
                if (this.client_segment === 0 || this.shopkeeper.includes(this.client_segment)) {
                    return '/download/tyc_conecta2.pdf'
                }
                if(this.staff.includes(this.client_segment)) {
                    return '/download/tyc_staff.pdf'
                }
                return '/download/tyc_contigo.pdf'
            },
        },
        mounted() {

        }
    }
</script>
